import { HTTP } from './helpers/http.js'

export default {
  postComment(organizationId, model, modelId, commentData) {
    const url = `/api/v1/organizations/${organizationId}/${model}/${modelId}/comments`
    return HTTP.post(url, commentData)
  },

  removeComment(organizationId, commentId) {
    const url = `/api/v1/organizations/${organizationId}/comments/${commentId}`
    return HTTP.delete(url)
  },

  getCommentsByModelId(organizationId, model, modelId) {
    const url = `/api/v1/organizations/${organizationId}/${model}/${modelId}/comments`
    return HTTP.get(url)
  },

  getCommentByModel(organizationId, model) {
    const url = `/api/v1/organizations/${organizationId}/${model}/comments`
    return HTTP.get(url)
  },

  getCommentByOrganization(organizationId) {
    const url = `/api/v1/organizations/${organizationId}/comments`
    return HTTP.get(url)
  },

  findCommentById(organizationId, commentId) {
    const url = `/api/v1/organizations/${organizationId}/comments/${commentId}`
    return HTTP.get(url)
  },
}
